// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1wQ3F","menu__container":"Menu_menu__container__2vjM4","error":"Menu_error__31g_T"};